import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const ImageWrapper = styled(Wrapper)`
  min-height: 120px;
`;

const TextWrapper = styled(Wrapper)`
  gap: 16px;
  text-align: center;
`;

const Title = styled.p`
  padding: 0;
  margin: 0;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: #000000;
`;

const Description = styled(Title)`
  font-size: 16px;
  line-height: 135%;
  color: #969696;
`;

export { Wrapper, ImageWrapper, TextWrapper, Title, Description };
